<template>
  <section class="related-categories card">
    <!-- @FIXME: waiting for PM to update i18n json -->
    <h3 class="title">更多相似類別</h3>
    <div class="flex flex-nowrap gap-2 overflow-auto no-scrollbar py-4">
      <nd-button v-for="t in props.product.tags" :key="t.id" class="whitespace-nowrap" size="small" type="secondary">{{ t.name }}</nd-button>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { UiProductInfo } from '@/types/product'

const props = defineProps<{
  product: UiProductInfo
}>()
</script>

<style lang="scss" scoped></style>
